import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const COOKIE_CONSENT_KEY = "autosur-cookie-consent";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const saveConsent = (accepted: boolean) => {
    const consentData = {
      accepted,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData));
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg"
        >
          <div className="container mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-6">
            <p className="font-body text-autosur-navy text-xs sm:text-sm text-center sm:text-left">
              Ce site utilise des cookies pour améliorer votre expérience de navigation. En continuant, vous acceptez notre{" "}
              <Link 
                to="/politique-confidentialite" 
                className="text-autosur-blue hover:text-autosur-red underline transition-colors"
              >
                politique de confidentialité
              </Link>.
            </p>
            
            <div className="flex items-center gap-3 shrink-0">
              <button
                onClick={() => saveConsent(false)}
                className="px-5 py-2 border border-autosur-navy text-autosur-navy font-heading font-medium text-xs sm:text-sm rounded hover:bg-autosur-navy/5 transition-colors"
              >
                Refuser
              </button>
              
              <button
                onClick={() => saveConsent(true)}
                className="px-5 py-2 bg-autosur-red text-white font-heading font-semibold text-xs sm:text-sm rounded hover:bg-autosur-red/90 transition-colors"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
